module.exports = __webpack_public_path__ + "static/hero3-beb70d30325bdbe5cfd4517f09ef367f.png";